<template>
    <div class="flex flex-wrap gap-2">
        <div
            v-for="element in filteredElements"
            :key="element.id"
            class="relative"
            :class="elementClass"
            :title="element.name"
        >
            <img :src="element.image_path" alt="" class="inset-0 object-contain absolute" />
            <BadgePill :color="element.count ? 'indigo' : 'gray'" class="absolute bottom-0 right-0 -mr-1 -mb-1">
                &times;{{ element.count }}
            </BadgePill>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TradeElementsDisplay',
};
</script>
<script setup>
import { computed } from 'vue';
import BadgePill from '@/components/BadgePill.vue';

const props = defineProps({
    elements: {
        type: Array,
        default: () => [],
        required: true,
    },
    selected: {
        type: Array,
        default: () => [],
        required: true,
    },
    side: {
        type: String,
        required: true,
    },
    elementClass: {
        type: String,
        default: 'w-20 h-20',
        required: false,
    },
});

const selectedElementsIds = computed(() => {
    return props.selected.filter((e) => e[props.side]).map((e) => e.id);
});

const filteredElements = computed(() => {
    return props.elements
        .filter((e) => selectedElementsIds.value.includes(e.id))
        .map((e) => {
            const find = props.selected.find((s) => s.id === e.id);
            e.count = find[props.side];
            return {
                id: e.id,
                name: e.name,
                image_path: e.image_path,
                count: find[props.side],
            };
        });
});
</script>
